// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"76cf2992","294":"7197fc8e","488":"97a82d18"}[chunkId] + ".chunk.js";
};